<template>
  <yxp-nav
    ref="yxpNav"
    @login-out="loginOut"
    @before-change="beforeChange"
    @change-identity="changeIdentity"
    @before-mqtt-msg-close="beforeMqttClose"
  >
    <template
      v-if="switchBtn"
      v-slot:switchBtn
    >
      <div
        class="navbtn fl"
        @click="switchClient"
      >
        {{ client === 'back' ? '进入应用' : $store.getters['system/getSuperAuth'] ? '进入应用' : '进入管理' }}
      </div>
    </template>
  </yxp-nav>
</template>

<script>
export default {
    name: 'WebPortal',
    data () {
        return {
            loading: null,
        };
    },
    computed: {
        switchBtn () {
            return this.$store.getters['system/clientPermission'] && this.$store.getters['system/permission'];
        },
        client () {
            let res = 'back';
            this.$route.matched.forEach(r => {
                if (r.meta.client) {
                    res = r.meta.client;
                }
            });
            return res;
        },
    },
    mounted () {
    },
    methods: {
        beforeChange (data) {
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(250, 250, 250, 0.4)',
            });
        },
        changeIdentity (data) {
            if (data.errcode === 0) {
                this.$store.dispatch('system/actAuthorize').then(() => {
                    this.$router.replace({
                        path: '/',
                        query: { reload: 1 },
                    });
                    setTimeout(() => {
                        this.loading.close && this.loading.close();
                        window.location.reload();
                    }, 400);
                }).catch(this.backToIndex);
            } else {
                this.loading.close && this.loading.close();
            }
        },
        loginOut () {
            this.$store.dispatch('system/act_clearAccount');
        },
        /* 无访问权限时, 返回首页 */
        backToIndex () {
            let self = this;
            self.$message({
                type: 'error',
                duration: process.env.NODE_ENV === 'development' ? 0 : 1500,
                showClose: true,
                message: '对不起，您暂时没有访问权限！',
                onClose () {
                    if (process.env.NODE_ENV === 'development') {
                        self.$store.dispatch('system/act_login_off', {
                            backUrl: location.origin + location.pathname,
                            path: '/',
                        });
                    } else {
                        self.$store.dispatch('system/act_backToIndex');
                    }
                },
            });
        },
        /* mqttt弹窗关闭前，清除登录信息，防止直接刷新 */
        beforeMqttClose (type) {
            let env = process.env.NODE_ENV === 'production';
            if (env) {
                /* 移除登录信息，防止用户不点击弹窗，直接刷新 */
                this.$store.dispatch('system/act_clearAccount');
            }
        },
        /* 切换前后台应用 */
        switchClient () {
            if (this.client === 'back') { // 当前是后台路由
                this.$router.push({
                    name: 'front',
                    query: { stack: -1 },
                });
                this.$store.commit('system/mu_superAuth', false);
            } else { // 当前是前台路由
                if (this.$store.getters['system/getSuperAuth']) {
                    this.$router.push({
                        name: 'front',
                        query: { stack: -1 },
                    });
                    this.$store.commit('system/mu_superAuth', false);
                } else {
                    this.$router.push({
                        name: 'pageDetail',
                    });
                }
            }
        },
    },
    beforeRouteEnter (to, from, next) {
        to.matched.some(itm => {
            if (itm.meta.documentTitle) {
                document.title = itm.meta.documentTitle;
                return true;
            }
        });
        next();
    },
    beforeRouteUpdate (to, from, next) {
        this.$refs.yxpNav && this.$refs.yxpNav.scrollBehavior();
        next();
    },
};
</script>
<style scoped>
.navbtn {
    margin-right: 16px;
    cursor: pointer;
}
</style>
